<template>
  <div :class="['flex w-full', isAssistant ? 'justify-end' : 'justify-start']">
    <template v-if="!isAssistant">
      <!-- User message -->
      <div class="flex gap-3 max-w-full items-start">
        <UserAvatar />
        <div class="bubble bubble-user" v-html="formatted" />
      </div>
    </template>
    <template v-else>
      <!-- Assistant message -->
      <!-- Layout switched to column so the bot avatar appears *above* the speech bubble -->
      <div class="flex flex-col gap-2 max-w-full items-end">
        <BotAvatar />
        <div class="bubble bubble-ai" v-html="formatted" />
      </div>
    </template>
  </div>
</template>

<script setup>
/* global defineProps */
import { computed, h, defineComponent } from 'vue';

const props = defineProps({
  role: { type: String, required: true },
  content: { type: String, required: true },
});

const isAssistant = computed(() => props.role === 'assistant');

const formatted = computed(() =>
  props.content.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>')
);

// Lightweight functional SVG avatar components --------------------------------
const UserAvatar = defineComponent({
  name: 'UserAvatar',
  setup() {
    return () => h('svg', {
      class: 'avatar text-gray-500', viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': 'true',
    }, [h('path', { d: 'M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-3.33 0-10 1.67-10 5v3h20v-3c0-3.33-6.67-5-10-5Z' })]);
  },
});

const BotAvatar = defineComponent({
  name: 'BotAvatar',
  setup() {
    return () => h('svg', {
      class: 'avatar text-indigo-600', viewBox: '0 0 24 24', fill: 'currentColor', 'aria-hidden': 'true',
    }, [h('path', { d: 'M12 2a5 5 0 0 0-5 5h10a5 5 0 0 0-5-5Zm-8 9v5a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-5H4Zm5 2h2v2H9v-2Zm4 0h2v2h-2v-2Z' })]);
  },
});

</script>

<style scoped>
.bubble {
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  max-width: 85%;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.12);
}

.bubble-user {
  background: #f3f4f6; /* gray-100 */
  color: #111827;      /* gray-900 */
}

.bubble-ai {
  background: #4f46e5; /* indigo-600 */
  color: #ffffff;
  box-shadow: 0 1px 4px rgb(79 70 229 / 0.4);
}

.avatar {
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
}
</style>